import { render, staticRenderFns } from "./matchcandi.vue?vue&type=template&id=278b3529&lang=pug"
import script from "./matchcandi.vue?vue&type=script&lang=js"
export * from "./matchcandi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports